export const GET_STATE_LOADING = "GET_STATE_LOADING";
export const GET_SURVEYS = "GET_SURVEYS";
export const GET_CURRENT_SURVEY = "GET_CURRENT_SURVEY";
export const GET_QUESTION_TYPES = "GET_QUESTION_TYPES";
export const GET_SURVEY_CONFIG = "GET_SURVEY_CONFIG";
export const GET_RESPONSES = "GET_RESPONSES";
export const GET_SUMMARY = "GET_SUMMARY";
export const GET_OVERVIEW = "GET_OVERVIEW";
export const GET_BOT_CONFIG = "GET_BOT_CONFIG";
